import { ServiceResponse } from "../ServiceResponse";

export class UpdateEmailAddressResponse extends ServiceResponse {
}
